import { render, staticRenderFns } from "./VehiclesginIndex.vue?vue&type=template&id=1df7ec0a"
import script from "./VehiclesginIndex.vue?vue&type=script&lang=js"
export * from "./VehiclesginIndex.vue?vue&type=script&lang=js"
import style0 from "./VehiclesginIndex.vue?vue&type=style&index=0&id=1df7ec0a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports